import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getUsersMeOrganisationsCurrentDashboardsByDashboardIdSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDashboardsByDashboardId
    .select;
